// extracted by mini-css-extract-plugin
module.exports = {"fixed":"fixed--2DhhH"};